module.exports = __webpack_public_path__ + "img/identifai-3.ea44bc1c.jpeg";